import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-paper-plane",
  "use": "icon-paper-plane-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-paper-plane\"><path d=\"M397.632 634.496L833.28 279.04l-435.584 468.8v133.248L620.8 761.92l212.608 122.88 87.04-737.28L183.68 515.84l213.952 118.592 431.104-351.616 0.512 0.576-346.88 373.312 350.912-377.6-435.648 355.328zM1024 0l-120.832 1024-283.968-164.16L312.128 1024v-339.008L0 512l1024-512z\" fill=\"#262626\" p-id=\"41050\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol